import Vue from 'vue'
import App from '@/App.vue';
import Notifications from 'vue-notification';
import NotifyPlugin from './plugins/NotifyPlugin';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import VueSimpleSpinner from 'vue-simple-spinner';
import 'vue-loaders/dist/vue-loaders.css';
import { BallPulseLoader, BallClipRotateLoader } from 'vue-loaders';
import Fragment from 'vue-fragment';
import {installFilters} from '@/plugins/BekFilters';
import PrettyInput from '@/components/pretty-input/PrettyInput.vue';
import store from '@/store';
import router from '@/router';

Vue.config.productionTip = false;
// ignore ionicons elements
Vue.config.ignoredElements = [/^ion-/];
Vue.use(Notifications);
Vue.use(NotifyPlugin);
// Plugin to hack around Vue's limitation that each component must have a single root element.
// Sometimes we want a component to contain multiple elements that should all pretend to be "root" elements
// so they can play nice with their grandparent's (the component's parent) styling (e.g. in CSS Gridbox)
Vue.use(Fragment.Plugin);

installFilters();

Vue.component(flatPickr.name, flatPickr);
Vue.component(VueSimpleSpinner.name, VueSimpleSpinner);
Vue.component(BallPulseLoader.name, BallPulseLoader);
Vue.component(BallClipRotateLoader.name, BallClipRotateLoader);
Vue.component('p-input', PrettyInput);

Vue.directive('uppercase', {
    update(el: any) {
        el.value = el.value.toUpperCase();
    },
});

new Vue({
    el: '#app',
    render: (h) => h(App),
    store,
    router
}).$mount('#app');
